import React from 'react';
import PropTypes from 'prop-types';

export const IconProviderOnlyPlay = ({ className }) => (
  <svg className={className} width="60" height="60" viewBox="0 0 60 60" fill="none">
    <path d="M30.2 55.4C16.2896 55.4 5 44.1104 5 30.2C5 16.2896 16.2896 5 30.2 5C44.1104 5 55.4 16.2896 55.4 30.2C55.4 44.1104 44.1104 55.4 30.2 55.4ZM30.2 11.72C19.9856 11.72 11.72 19.9856 11.72 30.2C11.72 40.4144 19.9856 48.68 30.2 48.68C40.4144 48.68 48.68 40.4144 48.68 30.2C48.68 19.9856 40.4144 11.72 30.2 11.72Z" fill="url(#icon-provider-only-play-linear_1)" />
    <path d="M30.2 38.5999C34.8392 38.5999 38.6 34.8391 38.6 30.1999C38.6 25.5607 34.8392 21.7999 30.2 21.7999C25.5608 21.7999 21.8 25.5607 21.8 30.1999C21.8 34.8391 25.5608 38.5999 30.2 38.5999Z" fill="url(#icon-provider-only-play-linear_2)" />
  </svg>
);

IconProviderOnlyPlay.propTypes = {
  className: PropTypes.string,
};

IconProviderOnlyPlay.defaultProps = {
  className: '',
};
